import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-labour-positions',
  templateUrl: './labour-positions.component.html',
  styleUrls: ['./labour-positions.component.css']
})
export class LabourPositionsComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public selectListFactories: FactoryItem[] = [];

    public selectListWorkGroups: WorkGroupItem[] = [];

    public gridLabourPositions?: GridOptions;

    public gridProductionOrders?: GridOptions;

    public selectedBgLabourPositionsMain: string = 'LABOURS';

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2561, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadFactories() {
        this.selectListFactories = await this.datatask.Post(2024);
    }

    private async loadWorkGroups() {
        if (!this.setting) return;

        this.selectListWorkGroups = await this.datatask.Post(2040, { factory_id: this.setting.factory_id });
    }

    private loadGridLabourPositions() {
        if (!this.setting) return;

        if (!this.gridLabourPositions) {
            this.gridLabourPositions = new Grid()
                .setRememberId('w_labourpositions_grid')
                .setLoadDataFunction({
                    method: 2562,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'labourpositions_new',
                    text: 'labourpositions_new',
                    tooltip: 'labourpositions_new',
                    translateTooltip: true,
                    func: () => {
                        this.stateService?.go('labourposition', {
                            labourposition_keyno: '0',
                            argtype: this.setting?.argtype,
                            argvalue: this.setting?.argvalue
                        });
                    },
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.gridLabourPositions?.gridfunc?.read();
        }
    }

    private loadGridProductionOrders() {
        if (!this.setting) return;

        if (!this.gridProductionOrders) {
            this.gridProductionOrders = new Grid()
                .setRememberId('w_labourpositions_active_pojob_grid')
                .setLoadDataFunction({
                    method: 2890,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.gridProductionOrders?.gridfunc?.read();
        }
    }

    public onTabChange() {
        if (this.selectedBgLabourPositionsMain === 'LABOURS') {
            this.loadGridLabourPositions();
        } else {
            this.loadGridProductionOrders();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'factory_id':
                Promise.all([
                    this.loadWorkGroups()
                ]).then(() => {
                    if (this.selectedBgLabourPositionsMain === 'LABOURS') {
                        this.loadGridLabourPositions();
                    } else {
                        this.loadGridProductionOrders();
                    }

                    Promise.resolve();
                });
                break;
            case 'workgrp_keyno':
                if (this.selectedBgLabourPositionsMain === 'LABOURS') {
                    this.loadGridLabourPositions();
                } else {
                    this.loadGridProductionOrders();
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadFactories();
        
        return Promise.all([
            this.loadWorkGroups()
        ]).then(() => {
            if (this.selectedBgLabourPositionsMain === 'LABOURS') {
                this.loadGridLabourPositions();
            } else {
                this.loadGridProductionOrders();
            }

            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    show_setting: string;
    webpage_heading: string;
    factory_id: string;
    workgrp_keyno: string;
}

interface FactoryItem {
    factory_id: string;
    factory_name: string;
    orderby: number;
}

interface WorkGroupItem {
    workgrp_keyno: string;
    workgrp_name: string;
    orderby: number;
}
